import React, { history, useEffect, useState, useMemo } from "react";
import Quick_links from "../../utility/Quick_links";
import Hiring from "../Jobs/Hiring";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import $, { parseJSON } from 'jquery';
import UsNumberValidate from '../../utility/usNumberValidate';
import { useNavigate } from 'react-router-dom';
import Services from "../../services/services";
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
const ProfileInfo = () => {
  const [stateData, setStateData] = useState([]);
  const [companyProfile, setCompanyProfile] = useState([]);
  const [categories, setCategory] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [jobshadowSelected, setjobshadowSelected] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [itemName, setFieldName] = useState('');
  const [stateSelected, setStateSelected] = useState('');
  const companyId = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
  const [profileDescription, setProfileDescription] = useState('');

  //  const {
  //    register,
  //    formState: { errors },
  //    handleSubmit
  //  } = useForm({
  //    criteriaMode: "all",mode: "onBlur" 
  //  });
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm();

  function validateCheck() {
    var isCheckbox = true;
    const checked = $('input[name="category"]:checked').length;

    if (checked >= 3) {
      $('input[name="category"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="category"]').prop('disabled', false);
    }



  }

  function handleChangeProfileDesc(content) {
    setProfileDescription(content);
  }

  function handleImageUploadBefore(files, info, uploadHandler) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1 = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      Services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function init_call_trigger() {

    //
    /////////////////
    $("#profileDescValidMsg").hide();
    if (companyId == null || companyId == "null") {
      //navigate('/login');
      navigate('/Home');
    }
    $('#yourphone2').usPhoneFormat();
    $("#successMessage").hide();
    $('#howtoapplyValidregex').hide();
    getIndustryData();
    getLocationCounty();

    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);


    ///////////////


    getProfileInfo();
    //

  }
  function validateState() {
    var isCheck = true;

    var stateValue = $("#state").val();
    // alert(stateValue);
    if (!stateValue) {
      isCheck = false;
      $("#stateError").html("State is required");

    } else {
      isCheck = true;
      $("#stateError").html("");
    }

    return isCheck;
  }

  function validateCategory() {
    // alert("@@category");
    var isCheck = true;

    var checkedValues = $("input[name='category']:checked");
    var lenghtCheck = checkedValues.length;
    if (lenghtCheck == 0) {
      isCheck = false;
      $("#categoryError").html("Category field is required");
    } else {
      isCheck = true;
      $("#categoryError").html("");
    }

    return isCheck;
  }

  const submitValue = () => {

    if (profileDescription == "") {
      $("#profileDescValidMsg").show();
      $("#profileDescValidMsg").focus();
      return false;
    }
    var validateEditorTxt = 1;
    var website_regex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi;
    var website = $('#website').val();
    var regexvalid = website_regex.test(website);
    console.log('**** ' + regexvalid);
    if (website != "" && regexvalid == false) {
      $("#howtoapplyValidregex").show();
      $(window).scrollTop($('#howtoapplyValidregex').position().top);
      validateEditorTxt = 0;
    }

    if (validateEditorTxt == 1 && validateCategory() && validateState()) {

      var categoriesArray = [];
      $.each($("input[name='category']:checked"), function () {
        categoriesArray.push($(this).val());
      });
      var jobshadow_concert = "";

      $.each($("input[name='job_shadow']:checked"), function () {
        jobshadow_concert = $(this).val();
      });
      console.log(JSON.stringify(categoriesArray));
      // var des =  CKEDITOR.instances['description'].getData;
      //alert(des);
      const requestObject =
      {
        "companyId": companyId,
        "countyId": "2",
        "name": $("#name").val(),
        "address1": $("#address1").val(),
        "address2": $("#address2").val(),
        "city": $("#city").val(),
        "state": $("#state").val(),
        "countyId": $("#county").val(),
        "zip": $("#zipcode").val(),
        "phone": $("#yourphone2").val(),
        "employeeCount": $("#employeeCount").val(),
        // "description": $("#description").val(),
        "description": profileDescription,
        "webSite": $("#website").val(),
        "companyCategory": categoriesArray,
        "jobShadowConcert": jobshadow_concert
      }


      var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + accessTokenIn
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };


      Services.editCompanyProfile(requestOptions).then((res) => {
        // alert(JSON.stringify(res));

        //navigate('/profileInfo');

        $("#form-reset").trigger("reset");



        init_call_trigger();
        $('#howtoapplyValidregex').hide();
        // $("#successMessage").show()
        $("#successMessage").fadeTo(2000, 1000).slideUp(1000, function () {
          $("#successMessage").slideUp(1000);
        });

      });
    }
  }

  useEffect(() => {
    const jsonData = {
      "profileInfo": {
        
      }
    };
    var jsondataformatted = JSON.stringify(jsonData);
    sessionStorage.setItem('pagejsonObject', jsondataformatted);

    $(".se-dialog-tabs").hide();
    init_call_trigger();


  }, []);

  function getProfileInfo() {

    //var companyId = "24";


    Services.getCompanyProfile(companyId).then((res) => {

      $("#name").val(res.data.name);
      $("#address1").val(res.data.address1);
      $("#address2").val(res.data.address2);
      $("#city").val(res.data.city);
      $("#state").val(res.data.state);
      $("#zipcode").val(res.data.zip);
      $("#yourphone2").val(res.data.phone);
      $("#website").val(res.data.webSite);
      $("#employeeCount").val(res.data.employeeCount);
      $("#description").val(res.data.description);
      //setProfileDescription(res.data.description);
      setStateSelected(res.data.state);
      setCompanyProfile(res.data);

      console.log(JSON.stringify(res.data.companyCategory));
      console.log("90-->");
      setCategoriesSelected(res.data.companyCategory);
      setjobshadowSelected(res.data.jobShadowConcert);
      var companyCatIn = res.data.companyCategory;

      setTimeout(() => {
        if (res.data.description) {
          setProfileDescription(res.data.description);
        }
        $("#county").val(res.data.countyId);

      }, 2000);

      setTimeout(() => {
        for (var i = 0; i < companyCatIn.length; i++) {
          //$("input[value='" + val + "']").prop('checked', true);
          console.log("###" + companyCatIn[i]);
          //$('input[name="category"][value="' + companyCatIn[i] + '"]').prop("checked", true);
          $('input[name="category"][value="' + companyCatIn[i] + '"]').trigger("click");
        }
        validateCheck();
        $('input[name="job_shadow"][value="' + res.data.jobShadowConcert + '"]').trigger("click");
        var isCheck = true;

        var checkedValues = $("input[name='category']").val();
        // var checkedValues = [];
        //     $.each($("input[name='category']:checked"), function () {
        //       checkedValues.push($(this).val());
        //     });
        // alert(checkedValues);
        if (!checkedValues) {
          isCheck = false;
          $("#categoryError").html("Category field is required");
        } else {
          // alert(checkedValues);
          isCheck = true;
          $("#categoryError").html("");
        }

        return isCheck;

        setTimeout(() => {
          console.log("141");
          $('input[name="category"]').trigger("change");
          $('input[name="state"]').trigger("change");
        }, 3000);

      }, 1000);



      //navigate('/thankyou');
    });
  }
  const getIndustryData = () => {

    Services.getIndustryData().then((res) => {

      console.log("Industry data=" + JSON.stringify(res.data));

      setCategory(res.data.content);

    });

  }

  const getLocationCounty = () => {
    Services.getLocationCounty().then((res) => {
      console.log("getLocationCounty data=" + JSON.stringify(res.data));
      setLocationCounty(res.data.content);
    });
  }
  return (
    <>
      <main class="empr-directory-main">
        <div class="main-bgpatten"></div>
        {/* <!-- info typography --> */}
        <section class="headtitle-wrap">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <nav style={{ "--bs-breadcrumb-divider": '>' }} aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item headtitle "><a href="/companyJobs">Company Dashboard</a> <span style={{ color: "#6c757d" }}>&#62;</span></li>
                    <li class="breadcrumb-item headtitle "><a href="#">Profile Edit </a></li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- info typography --> */}
        <section class="py-5">
          <div class="container">
            <div class="row">
              <div class="col-12 ">
                <div class="white-bg p-5">
                  <div class="row">
                    {/* <!-- left side --> */}
                    <Quick_links />
                    {/* <div class="col-lg-4 mb-4">
                               <div class="card p-3 ">
                                   <div class="bg-heading">
                                       <h3 class="mb-0">Quick Links </h3>
                                    </div>

                                    <div class="qlinks">
                                       <ul>
                                          
                                           <li><a href="profile-info.html" class="active">Profile Info </a></li>
                                           <li><a href="company-logo.html">Company Logo</a></li>
                                           <li><a href="video-upload.html">Upload Video</a></li>
                                          
                                    
                                       </ul>
                                       <div class="p-5 white-bg">
                                           <div class="text-center">
                                               <img src="images/Group 75.png" alt=""/>
                                           </div>
                                          <div class="text-cente">
                                           <h3 class="pb-3 border-bottom text-center">Upcoming Events</h3>
                                          <div class="pb-4 mt-4 border-bottom">
                                           <h4>CAREER FAIR</h4>
                                           <span>September 21, 2021</span>
                                           <p>Wright State University will be hosiint it’s 8th Annual Career Fair on October 21st.</p>
                                          </div>
       
                                          <div class="pb-4 mt-4 border-bottom">
                                           <h4>CAREER FAIR</h4>
                                           <span>September 21, 2021</span>
                                           <p>Wright State University will be hosiint it’s 8th Annual Career Fair on October 21st.</p>
                                          </div>
       
                                          <div class=" mt-4 ">
                                           <h4>CAREER FAIR</h4>
                                           <span>September 21, 2021</span>
                                           <p>Wright State University will be hosiint it’s 8th Annual Career Fair on October 21st.</p>
                                          </div>
                                          </div>
                                       </div>
                                   </div>
                               </div>
                               
                           </div> */}

                    {/* <!-- right side --> */}

                    <div class="col-lg-8 mb-4">
                      <form id="form-reset" onSubmit={handleSubmit(submitValue)}>
                        <div class="row resume-wrap">
                          <div class="col-lg-12 mb-4">
                            <label for="name" class="form-label">Company Name<span class="red-text">*</span></label>
                            <input type="text" class="form-control" defaultValue='Company Name' id="name" {...register('name', { required: true })} />
                            {errors.name && errors.name.type === "required" && <div class="error">First name is required</div>}
                            {/* <div class="invalid-feedback">
                                      Valid first name is required.
                                    </div> */}
                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="address1" class="form-label">Address<span class="red-text">*</span></label>
                            <input type="text" class="form-control" defaultValue='Address' id="address1" placeholder=""  {...register("Address", {
                              required: "Address is required.",

                            })} />
                            {errors.Address && errors.Address.type === "required" && <div class="error">Address  is required</div>}
                            {/* <ErrorMessage
                              errors={errors}
                              name="Address"
                              class="invalid-feedback"
                              render={({ messages }) => {
                                console.log("messages", messages);
                                return messages
                                  ? Object.entries(messages).map(([type, message]) => (
                                    <p key={type} class="error">{message}</p>
                                  ))
                                  : null;
                              }}
                            /> */}

                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="address2" class="form-label">Address2</label>
                            <input type="text" class="form-control" id="address2" defaultValue='Address edited' placeholder="" required="" />
                            {/* <div class="invalid-feedback">
                              Valid first name is required.
                            </div> */}
                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="city" class="form-label">City<span class="red-text">*</span></label>
                            <input type="text" class="form-control" defaultValue='City' id="city" placeholder=""  {...register("City", {
                              required: "City is required.",

                            })} />
                            {errors.City && errors.City.type === "required" && <div class="error">City  is required</div>}
                            {/* <ErrorMessage
                              errors={errors}
                              name="City"
                              class="invalid-feedback"
                              render={({ messages }) => {
                                console.log("messages", messages);
                                return messages
                                  ? Object.entries(messages).map(([type, message]) => (
                                    <p key={type} class="error">{message}</p>
                                  ))
                                  : null;
                              }}
                            /> */}

                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="state" class="form-label">State<span class="red-text">*</span></label>
                            <select class="form-select" aria-label="Default select example" id="state" onChange={() => validateState()}>
                              <option value="">Select</option>
                              {
                                stateData.map((state, index) => {

                                  // if(stateSelected==state.stateName)
                                  // {
                                  //     return <option value={state.stateName} selected>{state.stateName}</option>
                                  // }else{
                                  //     return <option value={state.stateName} >{state.stateName}</option>
                                  // }

                                  return <option value={state.stateCode} selected={companyProfile.state == state.stateCode ? "selected" : ""}>{state.stateName}</option>
                                })
                              }
                            </select>
                            <span id="stateError" class="red-text"></span>
                            {errors.state && errors.state.type === "required" && <div class="error">State is required</div>}
                            {/* <input type="text" class="form-control" id="firstName" placeholder=""  onChange={e => setFieldName(e.target.value)} {...register("State", {
                                    required: "State is required.",
                                    
                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="State"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />  */}

                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="zipcode" class="form-label">Zipcode<span class="red-text">*</span></label>
                            <input type="text" class="form-control" defaultValue="532222" name="zip" id="zipcode"  {...register("Zip", {
                              required: true,
                              pattern: /^[\d./-]+$/
                            })} />
                            {errors.Zip && errors.Zip.type === "required" && <div class="error">Zipcode  is required</div>}
                            {errors.Zip && errors.Zip.type === "pattern" && <div class="error">Should allow only numerics</div>}
                            {/* <ErrorMessage
                              errors={errors}
                              name="Zip"
                              class="invalid-feedback"
                              render={({ messages }) => {
                                console.log("messages", messages);
                                return messages
                                  ? Object.entries(messages).map(([type, message]) => (
                                    <p key={type} class="error">{message}</p>
                                  ))
                                  : null;
                              }}
                            /> */}

                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="firstName" class="form-label">County</label>
                            <select id="county" name="county" class="form-select" aria-label="Default select example">
                              <option selected="" value=''>Select</option>
                              {
                                locationCounty.map((data, index) => (
                                  <option value={data.jobLocationCountyId}
                                    selected={companyProfile.countyId == data.jobLocationCountyId ? "selected" : ""}
                                  >{data.name}</option>
                                ))}
                            </select>
                          </div>


                          <div class="col-lg-6 mb-4">
                            <label for="yourphone2" class="form-label">Phone<span class="red-text">*</span></label>
                            <input type="text" class="form-control" id="yourphone2" defaultValue='1234567890' name="contactNumber" placeholder=""  {...register("Phone", {
                              required: true,

                            })} />
                            {errors.Phone && errors.Phone.type === "required" && <div class="error">Phone  is required</div>}
                            {/* <ErrorMessage
                              errors={errors}
                              name="Phone"
                              class="invalid-feedback"
                              render={({ messages }) => {
                                console.log("messages", messages);
                                return messages
                                  ? Object.entries(messages).map(([type, message]) => (
                                    <p key={type} class="error">{message}</p>
                                  ))
                                  : null;
                              }}
                            /> */}

                          </div>





                          <div class="col-lg-6 mb-4">
                            <label for="employeeCount" class="form-label">Number of Employees<span class="red-text">*</span></label><small></small>
                            <input type="text" class="form-control" defaultValue='0' id="employeeCount"   {...register("Employees", {
                              required: true,
                              pattern: /^[\d./-]+$/,
                            })} />

                            {errors.Employees && errors.Employees.type === "required" && <div class="error">Number of Employees  is required</div>}
                            {errors.Employees && errors.Employees.type === "pattern" && <div class="error">Should allow only numerics</div>}

                            {/* <ErrorMessage
                              errors={errors}
                              name="Employees"
                              class="invalid-feedback"
                              render={({ messages }) => {
                                console.log("messages", messages);
                                return messages
                                  ? Object.entries(messages).map(([type, message]) => (
                                    <p key={type} class="error">{message}</p>
                                  ))
                                  : null;
                              }}
                            /> */}

                          </div>

                          <div class="col-lg-6 mb-4">
                            <label for="website" class="form-label">Website</label><small>Example: http://example.com</small>
                            <input type="text" class="form-control" id="website" placeholder="" required="" />
                            <div id="howtoapplyValidregex" className="error">Please enter valid website URL.</div>
                          </div>



                          <div class="col-lg-12 mb-4">
                            <div class="d-flex"><label for="description" class="form-label mr-2">Company Profile <span class="red-text">*</span></label> </div>
                            {/* <textarea class="form-control textarea" defaultValue='description' id="description" spellcheck="false"  {...register("description", {
                              required: true,
                              maxLength: 2000
                            })} />
                            {errors.description && errors.description.type === "required" && <div class="error">Company Profile  is required</div>}
                            {errors.description && errors.description.type === "maxLength" && <div class="error">Should not allow more than 2000 character</div>} */}

                            {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="description"
                            data={ profileDescription }
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setProfileDescription(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}

                            <SunEditor
                              setOptions={{
                                height: "400",
                                //buttonList: [['font', 'align'], ['image']]

                                buttonList: [
                                  ['undo', 'redo'],
                                  ['font', 'fontSize', 'formatBlock'],
                                  ['paragraphStyle', 'blockquote'],
                                  ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                  ['fontColor', 'hiliteColor', 'textStyle'],
                                  ['removeFormat'],
                                  '/', // Line break
                                  ['outdent', 'indent'],
                                  ['align', 'horizontalRule', 'list', 'lineHeight'],
                                  ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                                  ['fullScreen', 'showBlocks', 'codeView'],
                                  ['preview'],

                                  /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                                ]
                                //buttonList: buttonList.complex
                                // plugins: [font] set plugins, all plugins are set by default
                                // Other option
                              }}
                              onChange={handleChangeProfileDesc}
                              setContents={profileDescription}
                              //onImageUpload={handleImageUpload}
                              onImageUploadBefore={handleImageUploadBefore}
                            />

                          </div>

                          <p id="profileDescValidMsg" class="error">Description is required.</p>



                          <div class="col-lg-12 mb-4">
                            <div class="d-flex"><label for="category" class="form-label mr-2 mb-3">Company Industry<span class="red-text">*</span></label> <small>Max 3 Categories</small></div>

                            <div >
                              <div class="category-check-itm">
                                <ul class="category-check">
                                  {
                                    categories.map((data, index) => (

                                      <li>
                                        <input class="form-check-input" value={data.catId}

                                          type="checkbox" name="category" id={`category` + index} onClick={() => validateCheck()} />
                                        <label class="form-check-label" for={`category` + index}> {data.name} </label></li>

                                    ))}
                                </ul>
                              </div>
                            </div>
                            <span id="categoryError" class="error"></span>
                            {/* {...register("category", {required: true,})} */}
                            {/* {errors.category && errors.category.type === "required" && <div class="error">Category is required</div>} */}
                          </div>

                          <div class="col-lg-12 mb-4">
                            <div class="d-flex"><label for="industry" class="form-label mr-2 mb-3">Does your company provide Job Shadow opportunities?</label></div>

                            <div>
                              <div class="category-check-itm">
                                <input class="form-check-input" type="radio" value="Y" name="job_shadow" id="job_shadow_y" />  <label class="form-check-label" for="defaultCheck1"> Yes </label> &nbsp; &nbsp; <input class="form-check-input" type="radio" value="N" name="job_shadow" id="job_shadow_n" />  <label class="form-check-label" for="defaultCheck1"> No </label>
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-12">

                            <div class="d-flex justify-content-between align-items-end choose">

                              <div> <button type="submit" class="reg-button"  >Save</button></div>
                            </div><br />

                            {/* <div id="successMessage" class="alert alert-success" role="alert">
                              Profile info  has been updated successfully</div> */}

                            <div id="successMessage" class="alert">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <img src="/images/success-alert.png" alt="" />
                                  <strong class="mx-2">Success!</strong> Profile info  has been updated successfully.
                                </div>
                                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                              </div>
                            </div>

                          </div>

                        </div>
                      </form>
                    </div>

                  </div>
                </div>

              </div>

            </div>
          </div>
        </section>
        <section class="white-bg py-5">
          <div class="container">

          </div>
        </section>
      </main>
    </>

  )
};

ProfileInfo.propTypes = {};

ProfileInfo.defaultProps = {};

export default ProfileInfo;
